module.exports = __webpack_public_path__ + "img/bid_agent-4.bf09a0f3.png";